<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Z9FH2b/tc-custom/9781466822849.jpg?1728259128922" alt="This image is the cover for the book Wheelworld, To the Stars Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wheelworld, To the Stars Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Wheelworld</i> is the second visionary volume in Harry Harrison's phenomenal To the Stars trilogy.</b><br/><br/>An unforgiving planet where the sun is about to rise and will not set for another four years; where an ancient peasant hierarchy still rules a society equipped with the highest technology; where the people are as dependent on visiting ships as they are on the very air that they breathe; home for some, but for Jan Kulozki it is an eternal prison.<br/><br/>And when the ships don't come, Jan finds himself at the center of an epic struggle for power...and survival.<br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Harry Harrison
      </h2>
      
      <p class="authorDescription body article">Harry Harrison (1925&ndash;2012) began writing science fiction in the 1950s and remains one of the top-selling authors in the genre. Harrison is best known for his Stainless Steel Rat, Deathworld, and West of End series, as well as&#160;<I>Make Room! Make Room!</I>, which was turned into the movie&#160;<I>Soylent Green&#160;</I>starring Charlton Heston and Edward G. Robinson. His novels have appeared on the&#160;<I>New York Times</I>&#160;bestseller list, and in 2009 he was awarded the Damon Knight SF Grand Master Award by the Science Fiction Writers of America.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01a2f72f